import Axios from "axios";

export const getClosePayments = async (state,dispatch) => {
  dispatch({
    type: "Set_FreezScreen",
    freezScreen: true,
  });
  await Axios
      .get(`${process.env.REACT_APP_API_URL}site_setting/close_payments`)
      .then((response) => {
        if (response.data.success === true) {
          dispatch({
            type: "setClosePayments",
            closePayments: response?.data?.data,
          });
          dispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
        }
   
      })

      .catch((error) => {
        dispatch({
          type: "SHOW_ALERT",
          alertType: "warning",
          message: "Please check your network.",
        });
        dispatch({
          type: "Set_FreezScreen",
          freezScreen: false,
        });
      });

};